import { XIcon } from '@phosphor-icons/react';
import type { MouseEventHandler } from 'react';

import styles from './close-button.module.scss';

export type CloseButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  'aria-label'?: string;
  className?: string;
};

export function CloseButton({
  onClick,
  disabled,
  'aria-label': ariaLabel = 'Close',
  className,
}: CloseButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
      className={[styles.closeButton, className].filter(Boolean).join(' ')}
    >
      <XIcon />
    </button>
  );
}
